module.exports = __webpack_public_path__ + "static/media/igor-anany.5b05a97c.png";